export function NotFoundComponent() {
    return (
        <section id="content-main">
            <h1>Not found</h1>
            <h2>This is not the page you are looking for</h2>
        </section>
    )
}